import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=37197cd6&"
import script from "./CreateCompany.vue?vue&type=script&lang=ts&"
export * from "./CreateCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports